// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310945/js/" + chunkId + "." + {"44":"ee284ef6","225":"79ac3ec6","481":"f9b8001d","486":"f34ba30b","770":"5dfc4c72"}[chunkId] + ".0.9391098743147783.chunk.js";
};